const SYS_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
const PROD_LINK = 'https://businesspanel.pod.ir/';
const SANDBOX_LINK = 'http://sandbox.pod.ir:9010/';
const DEV_LINK = 'http://business-panel.sakku-pardis.ir:9010/';
const ALL_SERVICES_VISIBLE = false;

const getEnvFullUrl = () => {
  switch (SYS_ENVIRONMENT) {
    case 'development':
      return DEV_LINK;
    case 'sandbox':
      return SANDBOX_LINK;
    case 'production':
      return PROD_LINK;
    default:
      return PROD_LINK;
  }
};

export {
  SYS_ENVIRONMENT,
  PROD_LINK,
  SANDBOX_LINK,
  DEV_LINK,
  ALL_SERVICES_VISIBLE,
  getEnvFullUrl,
};

